export default "<div>\r\n    <h5>Manufactoring Plant</h5>\r\n    \r\n</div>\r\n"